var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageOnTopOfTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "17px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(107, 117, 124)",
    d: "M2.562,1.085 L13.554,1.085 L13.554,12.077 L2.562,12.077 L2.562,1.085 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    opacity: 0.478,
    fill: "rgb(50, 53, 55)",
    d: "M1.907,1.124 L2.573,0.458 L13.869,11.754 L13.203,12.419 L1.907,1.124 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    opacity: 0.478,
    fill: "rgb(50, 53, 55)",
    d: "M13.869,1.124 L13.203,0.458 L1.907,11.754 L2.573,12.419 L13.869,1.124 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(107, 117, 124)",
    d: "M0.607,14.544 L15.476,14.544 L15.476,16.435 L0.607,16.435 L0.607,14.544 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOnTopOfTextIcon);
export default __webpack_public_path__ + "static/media/image-on-top-of-text-icon.e2886f2c5605f575da97c2ba7a2967a8.svg";
export { ForwardRef as ReactComponent };